import _process from "process";
var exports = {};
var process = _process;

exports = ({
  stream = process.stdout
} = {}) => {
  return Boolean(stream && stream.isTTY && process.env.TERM !== "dumb" && !("CI" in process.env));
};

export default exports;